module.exports = __webpack_public_path__ + "static/media/fr-600.8c68ad96.webp";